import {LoginContainer} from '../containers/LoginContainer/index'

export const LoginPage = () => (
    <>
        <LoginContainer/>
    </>
)
